<template>
  <v-app>
    <v-container fluid>
      <v-row >
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        label="To Date"
                        density="compact"
                        single-line
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Ware House"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Department"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="department_id.value.value"
                        :items="getHrmDepartmentList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="department_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Purchase Requisition List</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/purchase/add-requisition')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Create Requisition
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.code="{item}">
                      <!-- <span
                        class="text-primary cursor-pointer over:underline font-medium"
                        @click="viewRequisition(item)"
                      >
                      </span> -->
                      {{ item.code }}
                  </template>

                  <template v-slot:item.requisition_date="{item}">
                        {{ formattedDate(item.requisition_date) }}
                  </template>

                  <template v-slot:item.approval_status_display="{ item }">
                    <v-chip
                      v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                      color="yellow-darken-3"
                      size="small"
                    >
                      Wating for {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                      color="green"
                      size="small"
                    >
                      Approved By {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                      color="red"
                      size="small"
                    >
                      Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                      v-else
                      color="green"
                      size="small"
                    >
                      {{ item.approval_status }}
                    </v-chip>
                  </template>

                  <template v-slot:item.status="{ item }">
                      <v-chip
                      :color="statusMap[item.status]?.color || 'grey'"
                      size="small"
                      class="text-capitalize"
                      >
                        {{ statusMap[item.status]?.label || "Unknown" }}
                      </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <!-- <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="brown"
                      @click="viewRequisition(item)"
                    /> -->
                    <v-btn
                      icon="mdi-pencil"
                      size="small"
                      variant="text"
                      color="orange"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath) && canEdit(item)"
                    />
                    <v-btn
                      icon="mdi-file-document"
                      size="small"
                      variant="text"
                      color="blue"
                      @click="viewPurchaseRequisitionInvoice(item)"
                      v-if="$updateAccess($route.fullPath)"
                    />
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import statusMap from "@/utils/statusMap";

export default {
  components: {
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    statusMap,
    headers: [
      { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
      { title: "Code", key: "code", align: "center", sortable: false },
      { title: "Department", key: "department.name", align: "left", sortable: false },
      { title: "Warehouse", align: "left", key: "warehouse.name", sortable: true },
      { title: "Purpose", align: "left", key: "purpose.name", sortable: true },
      { title: "Employee Name", align: "end", key: "created_by.full_name", sortable:true },
      {title:"Apply Date", align:"center" , key:"requisition_date", sortable:true},
      { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getHrmDepartmentList.length === 0) {
      this.$store.dispatch("getHrmDepartmentList");
    }
    if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    }
  },
  computed: {
    getSchema() {
      return this.$store.getters.getPurRequisitionList;
    },
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // from_date: yup.date().required().label('Requisition Date'),
        // department_id: yup.number().positive().integer().nullable().label('Department Name'),
        // warehouse_id: yup.number().positive().integer().nullable().label('Warehouse Name'),
      }),
    });

    const department_id = useField("department_id");
    const warehouse_id = useField("warehouse_id");
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getPurRequisitionList", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      from_date,
      to_date,
      errorMessages,
      department_id,
      warehouse_id,
      loading,
    };
  },
  methods: {
    formattedDate,
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    viewRequisition(item) {
      this.$router.push({ name: "requisition-view", params: { id: item.id } })
    },
    viewPurchaseRequisitionInvoice(item) {
      this.$router.push({
          name: "view-requisition-invoice",
          query: { id: item.id },
      });
    },
    editItem(item) {
      // this.$store.commit('setEditingRequisition', item);
      this.$router.push({
        name: "add-requisition",
        query: { id: item.id },
      });
      // this.data = { ...item };
      // this.dialog = true;
    },
    canEdit(item){
        return (!item.approval_status || item.approval_status.toLowerCase() !== 'approved' || item.status == 0)
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Code",
        "Department",
        "Employee Name",
        "Apply Date",
        "Warehouse",
        "Amount",
        "Approval Status",
        "Status",
      ];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.code,
        item.department.name,
        item.created_by.full_name,
        item.requisition_date,
        item.warehouse.name,
        item.amount,
        item.approved_ind === 1 ? "YES" : "NO",
        item.status == 1 ? "Active" : "Inactive",
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Purchase Requisition List",
        "purchase_requisition_list_" + this.$fileDate(),
        "landscape"
      );
    },
    exportToExcel() {
      var data = [
        [
          "#SL",
          "Code",
          "Department",
          "Employee Name",
          "Apply Date",
          "Warehouse",
          "Amount",
          "Approval Status",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.department.name,
          item.created_by.full_name,
          item.requisition_date,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES" : "NO",
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });
      this.$exportTableToExcel(
        data,
        "purchase_requisition_list_" + this.$fileDate()
      );
    },
    exportToCSV() {
      var data = [
        [
          "#SL",
          "Code",
          "Department",
          "Employee Name",
          "Apply Date",
          "Warehouse",
          "Amount",
          "Approval Status",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.department.name,
          item.created_by.full_name,
          item.requisition_date,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES" : "NO",
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });

      this.$exportTableToCSV(
        data,
        "purchase_requisition_list_" + this.$fileDate()
      );
    },
  },
  mounted() {
    this.from_date.value.value = new Date();
    this.to_date.value.value = new Date();
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
